export default "__VITE_ASSET__CawZGlsO__"